module.exports = __webpack_public_path__ + "static/media/banner_logo.54ab5d98.png";